import { Button, Typography } from "@mui/material";
import ColumnContainer from "../common/ColumnContainer";
import ModalComponent from "../common/ModalComponent";
import RowContainer from "../common/RowContainer";
import { FormattedMessage } from "react-intl";

const InfoModalComponent = ({
  className = [],
  openModal,
  handleCloseModal,
  confirmButton,
  handleConfirm,
  children,
}) => {
  const classNames = [...className, "confirm-credit-modal"].join(" ");
  return (
    <ModalComponent
      open={openModal}
      handleClose={handleCloseModal}
      className={classNames}
    >
      <ColumnContainer center align="center" padding="30px">
        {children}
        <RowContainer align="center" end minGap sx={{ alignSelf: "end" }}>
          <Button
            type="submit"
            fullWidth
            variant="outlined"
            color="primary"
            onClick={handleCloseModal}
          >
            <FormattedMessage id="button.back" />
          </Button>
          {confirmButton ? (
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleConfirm}
            >
              <FormattedMessage id="button.confirm" />
            </Button>
          ) : null}
        </RowContainer>
      </ColumnContainer>
    </ModalComponent>
  );
};
export default InfoModalComponent;
